import { shiftModalEditViewFormItemVerticalMargin } from 'modals/ShiftModal/src/views';
import { FormLabel } from 'modals/ShiftModal/src/views/EditView/EditView.styled';
import { SectionDivider } from 'modals/ShiftModal/ShiftModal.styled';
import { FC, Fragment } from 'react';
import { useTranslation } from 'hooks/useTranslation';
import { Flex } from 'components/Flex';
import { ShiftCustomFieldInput } from 'modals/ShiftModal/src/components/ShiftCustomFieldInput/ShiftCustomFieldInput';
import { useCreateTimeOffViewFormContext } from 'modals/TimeOffModal/views/CreateTimeOffView/CreateTimeOffView.form.context';
import { useCreateTimeOffViewDataContext } from 'modals/TimeOffModal/views/CreateTimeOffView/CreateTimeOffView.data.context';
import { CustomFieldsContent } from 'modals/TimeOffModal/TimeOffModalView.styled';
import { MobileLabel } from 'pages/CreateShiftsPage/BulkCreateShiftView/CreateShiftModal/src/views/DetailsView/DetailsView.styled';

const CreateTimeOffCustomFieldsViewContainer: FC = () => {
  const { t } = useTranslation();
  const { timeOffCustomFields } = useCreateTimeOffViewDataContext();
  const { values, onChange } = useCreateTimeOffViewFormContext();

  return (
    <CustomFieldsContent>
      {timeOffCustomFields && timeOffCustomFields.length > 0 && (
        <Fragment>
          <SectionDivider
            variant="Thin"
            margin={`${shiftModalEditViewFormItemVerticalMargin}px 0`}
          />
          {timeOffCustomFields?.map((customField) => {
            return (
              <Flex
                key={customField.id}
                flexDirection="column"
                margin={`0 0 ${shiftModalEditViewFormItemVerticalMargin}px 0`}
              >
                <FormLabel>
                  {customField.name}
                  {customField.mobile && (
                    <MobileLabel>&nbsp;({t('schedule:SHOWN_INTERNALLY_ON_MOBILE')})</MobileLabel>
                  )}
                </FormLabel>

                <ShiftCustomFieldInput
                  key={customField.id}
                  customField={customField}
                  value={(values?.[customField?.name] as string) ?? ''}
                  onChange={onChange}
                />
              </Flex>
            );
          })}
        </Fragment>
      )}
    </CustomFieldsContent>
  );
};

export const CreateTimeOffCustomFieldsViewComponent: FC = () => {
  return <CreateTimeOffCustomFieldsViewContainer />;
};
